import { render, staticRenderFns } from "./ForwardToOption.vue?vue&type=template&id=aa223a5e&scoped=true&"
import script from "./ForwardToOption.vue?vue&type=script&lang=js&"
export * from "./ForwardToOption.vue?vue&type=script&lang=js&"
import style0 from "./ForwardToOption.vue?vue&type=style&index=0&id=aa223a5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa223a5e",
  null
  
)

export default component.exports